import {fetch} from '~/lib/fetch';
import config from '~/configuration';

const retrieve = async (rob_request_id) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query ServiceRequest($rob_request_id: ID!) {
            serviceRequest: serviceRequest(
              rob_request_id: $rob_request_id
            ) {
              rob_request_id
              snapshot_id
              service_request_id
              rob_id
              parent_id
              datetime
              license
              vin_number
              kilometrage
              lessor
              type
              status
              expected_completion_date
              service_request_number
              replacement {
                sla
                type
                rob_rental_classes {
                  code
                  description
                }
                car
                costs
                reason
                datetime
                surcharge
                kilometrage
                days_charged
                rental_class
                charge_per_day
                duration_in_days
                free_kilometrage
                extension_comment
                extension_in_days
              }
              car {
                name
                brand
                fuel_type
                attributes
                apk_expiry
                entry_date
              }
              dealer {
                id
                name
                city
                short_name
                company_name
              }
              components {
                id
                name
                tasks {
                  id
                  rob_code
                  description
                  work_text
                  duration
                  hourly_rate
                  amount
                  discount
                  markup
                  original_work_time
                  calculated_work_time
                  original_duration
                  reference
                  is_main_task
                  warranty
                  leniency_amount
                  is_damage
                  parts {
                    id
                    description
                    number
                    source
                    price
                    quantity
                    discount
                    markup
                    gen_art_nr
                    action
                    location
                    repairs
                    attributes
                    service_cost
                    is_sla_part
                  }
                }
                rob_component {
                  price
                  rob {
                    code
                    description
                  }
                  status {
                    code
                    description
                  }
                  operation {
                    code
                    description
                  }
                  reason {
                    code
                    description
                  }
                  location
                }
              }
              rob_contract {
                leaseContract {
                  endDate
                  maximumMileage
                  rentalVehicle {
                    rentalClass
                    fuelType
                  }
                }
                permissions
              }
              last_message {
                timestamp
                content
                is_photo
                attachment_name
              }
              sla {
                codes {
                  rob_code
                  amount
                  item
                  is_conditional
                }
                tires {
                  codes {
                    rob_code
                    price
                    action
                  }
                  brands {
                    makeCode
                    discount
                    condition
                    order
                  }
                }
                replacement_vehicle {
                  rob_code
                  rental_class
                  fuel
                  value
                  amount
                  surcharges
                }
              }
            }
          }    
        `,
      variables: {
        rob_request_id,
      },
    }),
  });

  const {serviceRequest} = await response.json();

  return serviceRequest;
};

const preview = async (rob_request_id, rob_code) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        mutation Mutation($rob_request_id: ID!, $rob_code: String) {
            data:preview(
              rob_request_id: $rob_request_id,
              rob_code: $rob_code
            ) {
              success
            }
          } 
        `,
      variables: {
        rob_request_id,
        rob_code,
      },
    }),
  });

  const {data} = await response.json();

  return data;
};

export default {
  retrieve,
  preview,
};
